import { render, staticRenderFns } from "./ShippingInstructionVoyage.vue?vue&type=template&id=e0903492&scoped=true&"
import script from "./ShippingInstructionVoyage.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionVoyage.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionVoyage.vue?vue&type=style&index=0&id=e0903492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0903492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0903492')) {
      api.createRecord('e0903492', component.options)
    } else {
      api.reload('e0903492', component.options)
    }
    module.hot.accept("./ShippingInstructionVoyage.vue?vue&type=template&id=e0903492&scoped=true&", function () {
      api.rerender('e0903492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionVoyage.vue"
export default component.exports